/**
 * apps/battle/client/src/terminal/components/LongTextInput.tsx
 * Multi-line textarea for long-text command words
 * (Explain, Analyse, Assess, Discuss, Evaluate).
 *
 * Ctrl+Enter / Cmd+Enter submits. Plain Enter inserts newline.
 * Character count visible bottom-right (no hard cap).
 */
import { useEffect, useRef } from 'react';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  rows?: number;
  /** M10 — when false, paste into the answer field is blocked (anti-paste knob). */
  allowPaste?: boolean;
}

export function LongTextInput({ value, onChange, onSubmit, disabled, rows = 6, allowPaste = true }: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);
  return (
    <div className="tm-textarea-wrap">
      <textarea
        ref={ref}
        rows={rows}
        autoCapitalize="sentences"
        spellCheck={false}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onPaste={allowPaste ? undefined : (e) => e.preventDefault()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && value.trim()) {
            e.preventDefault();
            onSubmit();
          }
        }}
        placeholder="Type your answer. Ctrl+Enter (or Cmd+Enter) to submit."
      />
      <div className="tm-textarea-wrap__count">{value.length} chars</div>
    </div>
  );
}
